import React, { Component } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import IframeSpaStatePageReady from '@atlassian/jira-project-settings-apps-connect-apps/src/view/iframe-ready-state';
import IFrameLoader from './iframe-loader';

type ConfluenceArticleProps = {
	src: string;
	className: string | undefined;
	onIFrameLoaded?: () => void;
};

// eslint-disable-next-line jira/react/no-class-components
export default class ConfluenceArticleIFrame extends Component<ConfluenceArticleProps> {
	// go/jfe-eslint
	// eslint-disable-next-line react/sort-comp
	static defaultProps = {
		className: undefined,
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	static attachHostOffsetOverride(window: any) {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const calculateDepth = (hostWindow: any, offset = 0) => {
			let hostFrameOffset = 0;

			while (hostWindow !== window.top) {
				hostFrameOffset += 1;
				// eslint-disable-next-line no-param-reassign
				hostWindow = hostWindow.parent;
			}

			return hostFrameOffset - offset;
		};

		const containerDepth = calculateDepth(window);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, no-param-reassign
		window.top.getHostOffsetFunctionOverride = (hostWindow: any) =>
			calculateDepth(hostWindow, containerDepth + 1);
	}

	static detachHostOffsetOverride() {
		if (window.top && window.top.getHostOffsetFunctionOverride) {
			delete window.top.getHostOffsetFunctionOverride;
		}
	}

	componentDidMount() {
		ConfluenceArticleIFrame.attachHostOffsetOverride(window);
	}

	componentWillUnmount() {
		ConfluenceArticleIFrame.detachHostOffsetOverride();
	}

	render() {
		const { src, onIFrameLoaded, ...props } = this.props;
		return (
			<Article {...props}>
				<IFrameLoader
					title="confluence-article-iframe"
					src={src}
					sameOriginResize
					resizePoll
					onIFrameLoaded={onIFrameLoaded}
				/>
				<IframeSpaStatePageReady src={src} />
			</Article>
		);
	}
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Article = styled.article({
	/* This works around the Confluence iframe having a padding of 20px. */
	marginLeft: token('space.negative.250', '-20px'),
	marginTop: token('space.negative.250', '-20px'),
	marginRight: token('space.negative.250', '-20px'),
});
